(function () {
  'use strict'

  require('./scss/module-video-promo.scss')

  const MODULE_NAME = 'thismoment.glow.component.module.video-promo'
  const templateUrl = require('./tpl/module-video-promo.html')

  angular
    .module(MODULE_NAME, [])
    .component('thismomentGlowModuleVideoPromo', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        autoplayEnabled: '<',
        content: '<',
        margin: '<'
      },
      controller: glowVideoPromoController
    })

  glowVideoPromoController.$inject = []
  function glowVideoPromoController () {
    const vm = this

    vm.styles = {}
    vm.$onInit = videoPromoInit

    function videoPromoInit () {
      if (vm.content.source.source_id === 0) {
        vm.displayVideo = true
      } else {
        vm.displayYoutube = true
      }
      vm.styles = {
        wrapper: {
          margin: vm.margin
        }
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-video-promo/index.js